import { cn } from '@/lib/utils';

interface SidebarNavLabelProps {
  label: string;
  collapsed: boolean;
}

export const SidebarNavLabel = ({ label, collapsed }: SidebarNavLabelProps) => {
  return (
    <span
      className={cn(
        'transition-all duration-200 overflow-hidden',
        // Expanded: fill the remaining row width and wrap long labels onto a
        // second line (e.g. "Secure AI Coding Enforcement") instead of clipping.
        // Collapsed: nowrap + max-w-0 so it shrinks away cleanly.
        collapsed
          ? 'opacity-0 max-w-0 p-0 m-0 inline-block whitespace-nowrap'
          : 'opacity-100 min-w-0 flex-1 whitespace-normal break-words'
      )}
    >
      {label}
    </span>
  );
};
